// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function sendContactForm(data) {
  return {
    type: types.SEND_CONTACT_FORM,
    data,
  };
}

// FIELDS

export function changeField(value, field) {
  return {
    type: types.CONTACT_FIELD_CHANGE,
    value,
    field
  };
}

export function changeErrors(field, error) {
  return {
    type: types.CONTACT_ERRORS_CHANGE,
    field,
    error
  };
}

//

export function setMessage(message) {
  return {
    type: types.SET_MESSAGE,
    message
  };
}

export function resetForm() {
  return {
    type: types.RESET_FORM,
  };
}

//

export function requestPageData(data) {
  return {
    type: types.CONTACT_REQUEST_PAGE_DATA,
    ...data
  };
}

export function requestPageDataSuccess(data) {
  return {
    type: types.CONTACT_REQUEST_PAGE_DATA_SUCCESS,
    data,
  };
}
